/* eslint-disable import/prefer-default-export */
import React from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";

const duration = 500;
const verticalOffset = 16;
const noop = () => {};

function AnimatedTransition({
  component: Component,
  in: hasEntered,
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  style,
  styleDefault,
  transition,
  ...props
}) {
  const transitionProps = {
    appear: true,
    in: hasEntered,
    mountOnEnter: true,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    timeout: duration,
    unmountOnExit: true
  };

  return (
    <Transition {...transitionProps}>
      {status => {
        if (status === "exited") return null;

        const styles = {
          ...style,
          ...styleDefault,
          ...transition[status]
        };

        return <Component style={styles} {...props} />;
      }}
    </Transition>
  );
}

AnimatedTransition.propTypes = {
  component: PropTypes.func.isRequired,
  in: PropTypes.bool,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  styleDefault: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  transition: PropTypes.shape({
    entering: PropTypes.object,
    entered: PropTypes.object,
    exiting: PropTypes.object,
    exited: PropTypes.object
  })
};

export const Fade = props => (
  <AnimatedTransition
    styleDefault={{
      transition: `opacity ${duration / 2}ms`
    }}
    transition={{
      entering: { opacity: 0 },
      entered: { opacity: 1 },
      exiting: { opacity: 0 }
    }}
    {...props}
  />
);

export const SlideUp = ({ ...props }) => {
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  const xVal = isIE ? 30 : 0;

  const restingTransform = `translate3d(${xVal}px, 0px, 0px)`;

  return (
    <AnimatedTransition
      styleDefault={{
        transition: `transform ${duration}ms`,
        transform: restingTransform
      }}
      transition={{
        entering: {
          transform: `translate3d(${xVal}px, ${verticalOffset * 2}px, 0px)`
        },
        entered: {
          transform: restingTransform
        },
        exiting: {
          transform: `translate3d(${xVal}px, -${verticalOffset * 2}px, 0px)`
        }
      }}
      {...props}
    />
  );
};

AnimatedTransition.defaultProps = {
  in: false,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop,
  transition: null,
  style: null
};
